import React from "react";
import "./Login.scss";
import {MDBBox} from "mdbreact";
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux'
import {compose} from 'redux';
import MobileNumberEntry from "../MobileNumberEntry/MobileNumberEntry";
import OTPForm from "../OTPForm/OTPForm";
import CreateNewPin from "../CreateNewPin/CreateNewPin";
import VerifyPin from "../VerifyPin/VerifyPin";
import ScratchCardComponent from "../../component/ScratchCard/ScratchCardComponent";
import CheckUsername from "../CheckUsername/CheckUsername";
import {setForgetPin} from "../../Actions";
import {assetUrl} from "../../serviceApi";
import {isJwtExpired} from "jwt-check-expiration";
import {MDBModal, MDBModalBody} from "mdbreact";

const envelope = assetUrl + 'images/animation_closed_envelope.svg'

class Login extends React.Component {

	state = {
		login_step: 0,
		initCircleRotation: false,

	}



	componentDidMount() {

		let token = localStorage.getItem("token")
		if (token) {
			let checkifExpire = isJwtExpired(token)
			if (checkifExpire) {
				localStorage.clear()
			}
			//use when onboarding is hide

			// else{
			// 	this.props.history.push("/home");
			// }

			console.log("checkifExpire",checkifExpire)

		}
		this.setState({
			login_step: 0
		})


		document.body.style = "overflow:auto"
		let pathname = window.location.pathname
		let splittedPathname = pathname.split("/login/")

		if (splittedPathname.length > 1) {
			// console.log(splittedPathname[1])
			localStorage.setItem("refCode", splittedPathname[1])

		} else {
			localStorage.setItem("refCode", "")
		}

		this.setState({
			login_step: this.props.login_step
		})
		// document.body.style = "overflow:auto";
	}
	componentWillReceiveProps(nextProps, nextContext) {
		this.setState({
			login_step: nextProps.login_step
		})
	}

	handleLoginSteps = (data) => {
		this.setState({
			login_step: data
		})
	}

	circleRotation = () => {
		this.setState({...this.state, initCircleRotation: true})
		setTimeout(
			function () {
				this.setState({...this.state, initCircleRotation: false})
			}
				.bind(this),
			2500
		);
	}
	closeLoginForm = () => {
		this.props.closeModal();
	}

	render() {
		const {isOpen,closeModal} = this.props;
		const component_list = [
			//temp check

			<MobileNumberEntry handleLoginSteps={this.handleLoginSteps}
			                   initCircleRotation={() => this.circleRotation()}
							   closeLoginForm={this.closeLoginForm}
							  />,
			<OTPForm handleLoginSteps={this.handleLoginSteps}
					 forgetPinIs={this.props.forgetPin}
			         initCircleRotation={() => this.setState({...this.state, initCircleRotation: false})}

			/>,
			<CheckUsername handleLoginSteps={this.handleLoginSteps}

			/>,
			<CreateNewPin handleLoginSteps={this.handleLoginSteps}
						  forgetPinIs={this.props.forgetPin}
						  completeLogin={this.props.completeLogin}

			/>,
			<ScratchCardComponent
				handleLoginSteps={this.handleLoginSteps}

			/>,
			<VerifyPin handleLoginSteps={this.handleLoginSteps}
					   forgetPin={(args) => this.props.setForgetPin(args)}
					   completeLogin={this.props.completeLogin}
			/>,

		];
		return (
			<MDBBox className="login-component ">

				{/*{this.state.initCircleRotation && <div className={"circle-wrap"}>*/}
				{/*	<div className={"envelope-circle"}>*/}
				{/*		<img src={envelope} alt={"alt"} className={"envelope-object"}/>*/}
				{/*	</div>*/}
				{/*</div>}*/}
				<MDBModal isOpen={isOpen} toggle={closeModal} fullHeight={true} position="bottom" id={"login-modal"}>
					<MDBModalBody>
						<MDBBox>
							{
								component_list[this.state.login_step]
							}
						</MDBBox>
					</MDBModalBody>
				</MDBModal>


			</MDBBox>
		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details,
	login_step: state.UserReducer.login_step,
	forgetPin: state.UserReducer.forgetPin
})
const mapDispatchToProps = dispatch => ({
	setForgetPin: data => dispatch(setForgetPin(data))
})

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(Login);
